import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

const NotFoundPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "404 - Pagina nu a fost găsită";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="app-bg min-h-screen text-[var(--text)]" data-testid="not-found-page">
      <section className="section" data-testid="not-found-section">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="glass-strong rounded-2xl sm:rounded-3xl p-6 sm:p-10"
          >
            <div className="inline-flex items-center gap-2 tag" data-testid="not-found-tag">
              <AlertTriangle size={12} />
              Error 404
            </div>

            <h1
              className="font-display text-3xl sm:text-5xl font-bold tracking-tight mt-4 leading-[1.05]"
              data-testid="not-found-title"
            >
              Pagina nu a fost găsită
            </h1>

            <p className="mt-4 text-sm sm:text-base leading-relaxed text-[var(--text-dim)]" data-testid="not-found-description">
              Pagina pe care ai accesat-o nu mai există, a fost mutată sau adresa introdusă este incorectă.
            </p>

            <p className="mt-2 text-sm sm:text-base leading-relaxed text-[var(--text-dim)]" data-testid="not-found-help">
              Verifică URL-ul și revino la secțiunile principale pentru a continua antrenamentul.
            </p>

            <nav className="mt-6 sm:mt-7 flex flex-wrap gap-2.5 sm:gap-3" aria-label="Acțiuni recomandate" data-testid="not-found-actions">
              <Link to="/" className="btn-primary inline-flex items-center justify-center" data-testid="not-found-home">
                Acasă
              </Link>
              <Link to="/#pricing" className="btn-ghost inline-flex items-center justify-center" data-testid="not-found-pricing">
                Abonamente
              </Link>
              <Link to="/#contact" className="btn-ghost inline-flex items-center justify-center" data-testid="not-found-contact">
                Contact
              </Link>
            </nav>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

export default NotFoundPage;
